import { render, staticRenderFns } from "./TooltipTextHelper.vue?vue&type=template&id=b70843f6&scoped=true"
import script from "./TooltipTextHelper.vue?vue&type=script&lang=js"
export * from "./TooltipTextHelper.vue?vue&type=script&lang=js"
import style0 from "./TooltipTextHelper.vue?vue&type=style&index=0&id=b70843f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b70843f6",
  null
  
)

export default component.exports